import { AxiosInstance } from 'axios';
import { useEffect } from 'react';
import { useLoader } from '../../providers/loader-provider';

let requestCount = 0;

const useAxiosLoader = (instance: AxiosInstance, isLoaderEnabled = true) => {
  const { startLoading, stopLoading } = useLoader();

  useEffect(() => {
    if (!isLoaderEnabled) return;
    if (!instance?.interceptors?.request) return;

    const requestInterceptor = instance.interceptors.request.use(
      request => {
        if (requestCount === 0) {
          startLoading('axios');
        }
        requestCount++;
        return request;
      },
      error => {
        return Promise.reject(error);
      },
    );

    const responseInterceptor = instance.interceptors.response.use(
      response => {
        requestCount--;
        if (requestCount === 0) {
          stopLoading('axios');
        }
        return response;
      },
      error => {
        requestCount--;
        if (requestCount === 0) {
          stopLoading('axios');
        }
        return Promise.reject(error);
      },
    );

    return () => {
      instance.interceptors.request.eject(requestInterceptor);
      instance.interceptors.response.eject(responseInterceptor);
    };
  }, [instance, startLoading, stopLoading]);
};

export default useAxiosLoader;
